















import { Component, Prop, Vue } from 'vue-property-decorator';
import { MentoringAvatarStub } from './components';
import { Classes, IMentoringAvatar, TypeEnum } from './types';

@Component({
  components: {
    MentoringAvatarStub,
  },
})
export default class MentoringAvatar extends Vue implements IMentoringAvatar {
  @Prop({ type: String, default: 'normal' })
  readonly size!: string;

  @Prop({ type: String, default: '' })
  readonly type!: string;

  @Prop({ type: Boolean, default: false })
  readonly asCurator!: boolean;

  @Prop({ type: String, default: 'M' })
  readonly gender!: string;

  @Prop({ type: String, default: '' })
  readonly photo!: string;

  get classes(): Classes {
    const result = [`avatar_${this.size}`];
    if (this.photo) result.push('avatar_photo');
    if (
      this.gender === 'N' ||
      this.type === TypeEnum.CURATOR ||
      this.type === TypeEnum.MENTOR
    )
      result.push('avatar_nogender');
    return result;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/components/avatar/MentoringAvatar.vue